var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRenewPrescription(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.37189,
    y: 20.4141,
    width: 9.08571,
    height: 8.32857,
    fill: "#FF8165"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16872 1.48828H21.0194C21.858 1.48828 22.544 2.04578 22.544 2.72719V7.06358C22.544 7.74507 21.858 8.30257 21.0194 8.30257H8.16872C7.33019 8.30257 6.64404 7.74507 6.64404 7.06358V2.72719C6.64404 2.04578 7.33019 1.48828 8.16872 1.48828Z",
    fill: "#A020FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31977 1.64062H20.7145C21.5234 1.64062 22.1851 2.31261 22.1851 3.13395V8.36085C22.1851 9.18229 21.5234 9.85427 20.7145 9.85427H8.31977C7.51099 9.85427 6.84918 9.18229 6.84918 8.36085V3.13395C6.84918 2.31261 7.51099 1.64062 8.31977 1.64062Z",
    stroke: "#081E54",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3777 10.7695V11.5249C20.3777 14.339 24.8883 14.4684 24.8883 16.8768V19.5127",
    stroke: "#081E54",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5021 35.4105H6.27841C5.10509 35.4105 4.14081 34.4156 4.14081 33.199V17.2887C4.14081 14.7118 8.24202 14.5816 8.24202 11.5756V10.7695",
    stroke: "#081E54",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14081 18.9805H13.4292V29.0194H4.14081V18.9805Z",
    stroke: "#081E54",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0006 28C37.0006 32.9706 32.9712 37 28.0006 37C23.03 37 19.0006 32.9706 19.0006 28C19.0006 23.0294 23.03 19 28.0006 19",
    stroke: "#081E54",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9987 25V29H31.9987",
    stroke: "#FF8165",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.0006,
    cy: 28,
    r: 9,
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeDasharray: "0.5 3.5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewPrescription);
export default __webpack_public_path__ + "static/media/RenewPrescription.00b6f48fec9bbb4393f9c0c64f8af016.svg";
export { ForwardRef as ReactComponent };